<template>
  <div class="page-box">
    <!--认证审核中-->
    <div v-if="active == 'A0' || active == 'A3'" class="qualification-top">
      <img src="@/assets/images/certification2.png" />
      <span>资质认证审核中, 审核时间预计3-5个工作日</span>
    </div>
    <!--认证成功-->
    <div v-if="active == 'A1'" class="qualification-top active">
      <img src="@/assets/images/certification4.png" />
      <span>认证成功</span>
    </div>
    <!--认证成功-->
    <div v-if="active == 'A2'" class="qualification-top unsuccessful">
      <img src="@/assets/images/certification2.png" />
      <span>资质认证失败,请重新提交</span>
    </div>
    <div class="qualification-form">
      <div class="qualification-input">
        <div class="qualification-left necessary-text">真实姓名</div>
        <div class="qualification-right">
          <el-input v-model="formInfo.doctorName" :disabled="isModifiable()" placeholder="请输入姓名"></el-input>
        </div>
      </div>
      <div class="qualification-input">
        <div class="qualification-left">所属医院</div>
        <div class="qualification-right">
          <el-input v-model="formInfo.hospital" :disabled="isModifiable()" placeholder="请输入所属医院"></el-input>
        </div>
      </div>
      <div class="qualification-input">
        <div class="qualification-left">当前职称</div>
        <div class="qualification-right">
          <!-- <el-input v-model="formInfo.position" :disabled="isModifiable()" placeholder="请输入当前职称"></el-input> -->
          <el-select v-model="formInfo.position" :disabled="isModifiable()" placeholder="请选择当前职称">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="upload-box">
      <div class="upload-li">
        <div class="upload-top">
          <img src="@/assets/images/certification6.png" />
          <div class="upload-text">
            <div class="upload-h necessary-text-two">实名认证信息</div>
            <div class="upload-p">请上传清晰的身份证照片</div>
          </div>
        </div>
        <div class="upload-bottom">
          <div class="identity-card-upload is-mgb-12">
            <div class="identity-card-left">
              <div class="identity-card-title">头像面</div>
              <div class="identity-card-subhead">上传您身份证的头像面</div>
            </div>
            <div class="identity-card-right">
              <el-upload action="" list-type="picture-card" :show-file-list="false" :disabled="isModifiable()"
                :file-list="formInfo.idCardAvatar"
                :before-upload="(file) => { return beforeUpload(file, 'idCardAvatar') }">
                <img v-if="!formInfo.idCardAvatar || formInfo.idCardAvatar.length <= 0" class="identity-card-img"
                  src="@/assets/images/identity_card.png" alt="">
                <img v-else class="identity-card-img"
                  :src="formInfo.idCardAvatar.length > 0 ? formInfo.idCardAvatar[0].url : ''" alt="">
              </el-upload>
            </div>
          </div>
          <div class="identity-card-upload">
            <div class="identity-card-left">
              <div class="identity-card-title">国徽面</div>
              <div class="identity-card-subhead">上传您身份证的国徽面</div>
            </div>
            <div class="identity-card-right">
              <el-upload action="" list-type="picture-card" :show-file-list="false" :disabled="isModifiable()"
                :file-list="formInfo.idCardNational"
                :before-upload="(file) => { return beforeUpload(file, 'idCardNational') }">
                <img v-if="!formInfo.idCardNational || formInfo.idCardNational.length <= 0" class="identity-card-img"
                  src="@/assets/images/identity_card_two.png" alt="">
                <img v-else class="identity-card-img"
                  :src="formInfo.idCardNational.length > 0 ? formInfo.idCardNational[0].url : ''" alt="">
              </el-upload>
            </div>
          </div>
        </div>
        <div class="authentication-note" v-if="active == 'A2' && this.userInfo.doctor.idCardNote != ''">
          失败原因：{{ this.userInfo.doctor.idCardNote }}
        </div>
      </div>
      <div class="upload-li">
        <div class="upload-top">
          <img src="@/assets/images/certification3.png" />
          <div class="upload-text">
            <div class="upload-h necessary-text-two">上传执业证</div>
            <div class="upload-p">请上传清晰的封面图和证件照</div>
          </div>
        </div>
        <div class="upload-bottom">
          <el-upload action="''" list-type="picture-card" :disabled="isModifiable()"
            :file-list="formInfo.practicingCard" :limit="5" :on-exceed="handleExceed"
            :before-upload="(file) => { return beforeUpload(file, 'practicingCard') }">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete"
                  @click="handleRemove(file, 'practicingCard')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </div>
        <div class="authentication-note" v-if="active == 'A2' && this.userInfo.doctor.practicingNote != ''">
          失败原因：{{ this.userInfo.doctor.practicingNote }}
        </div>
      </div>
      <div class="upload-li">
        <div class="upload-top">
          <img src="@/assets/images/certification3.png" />
          <div class="upload-text">
            <div class="upload-h">上传医师资格证</div>
            <div class="upload-p">请上传清晰的封面图和证件照</div>
          </div>
        </div>
        <div class="upload-bottom">
          <el-upload action="''" list-type="picture-card" :disabled="isModifiable()"
            :file-list="formInfo.qualificationCard" :limit="5" :on-exceed="handleExceed"
            :before-upload="(file) => { return beforeUpload(file, 'qualificationCard') }">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete"
                  @click="handleRemove(file, 'qualificationCard')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </div>
        <div class="authentication-note" v-if="active == 'A2' && this.userInfo.doctor.qualificationNote != ''">
          失败原因：{{ this.userInfo.doctor.qualificationNote }}
        </div>
      </div>
      <div class="upload-li">
        <div class="upload-top">
          <img src="@/assets/images/certification5.png" />
          <div class="upload-text">
            <div class="upload-h">上传工作证明</div>
            <div class="upload-p">添加一个备注，指出工牌或其他可证明在职的证件</div>
          </div>
        </div>
        <div class="upload-bottom">
          <el-upload action="''" list-type="picture-card" :disabled="isModifiable()" :file-list="formInfo.employeeCard"
            :limit="5" :on-exceed="handleExceed"
            :before-upload="(file) => { return beforeUpload(file, 'employeeCard') }">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file, 'employeeCard')">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </div>
        <div class="authentication-note" v-if="active == 'A2' && this.userInfo.doctor.employeeNote != ''">
          失败原因：{{ this.userInfo.doctor.employeeNote }}
        </div>
      </div>
      <el-input type="textarea" :disabled="isModifiable()" :rows="2" placeholder="输入备注信息" v-model="formInfo.remark">
      </el-input>
      <el-button v-if="active == 'AA'" type="primary" @click="onClickSend">提交</el-button>
      <el-button v-if="active != 'AA'" type="primary" @click="onClickSend">重新提交</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <div class="dialog-img-box">
        <img width="100%" :src="dialogImageUrl" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadDoctor, changeDoctorInfo, getCurrentUser } from '@/api/user'
export default {
  name: "Qualification",
  components: {
  },
  data() {
    return {
      active: '',
      dialogImageUrl: '', //预览图片地址
      dialogVisible: false, // 是否显示预览图片
      disabled: false, // 是否显示删除按钮
      userInfo: {},
      formInfo: {
        doctorName: '',
        hospital: '',
        position: '',
        remark: '',
        qualificationCard: [],
        practicingCard: [],
        employeeCard: [],
        idCardAvatar: [],
        idCardNational: [],
      },
      options: [
        {
          value: '住院医师',
          label: '住院医师',
        },
        {
          value: '主治医师',
          label: '主治医师',
        },
        {
          value: '副主任医师',
          label: '副主任医师',
        },
        {
          value: '主任医师',
          label: '主任医师',
        },
        {
          value: '主任护师',
          label: '主任护师',
        },
        {
          value: '副主任护师',
          label: '副主任护师',
        },
        {
          value: '主管护师',
          label: '主管护师',
        },
        {
          value: '护师',
          label: '护师',
        },
        {
          value: '护士',
          label: '护士',
        },
        {
          value: '主任中医师',
          label: '主任中医师',
        },
        {
          value: '副主任中医师',
          label: '副主任中医师',
        },
        {
          value: '主治中医师',
          label: '主治中医师',
        },
        {
          value: '中西医',
          label: '中西医',
        },
        {
          value: '技师',
          label: '技师',
        },
        {
          value: '研究员',
          label: '研究员',
        },
        {
          value: '副研究员',
          label: '副研究员',
        },
        {
          value: '助理研究员',
          label: '助理研究员',
        },
        {
          value: '研究实习员',
          label: '研究实习员',
        },
        {
          value: '其他',
          label: '其他',
        }],
    }
  },
  methods: {
    // 删除图片
    handleRemove(file, name) {
      let fileIndex = this.formInfo[name].findIndex((item) => item.url == file.url)
      if (fileIndex !== -1) {
        this.formInfo[name].splice(fileIndex, 1)
      }
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 点击下载文件
    handleDownload(file) {
      console.log(file);
    },
    // 超出上传数量限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制上传 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 上传前判断
    beforeUpload(file, name) {
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择有效图片!')
        return false
      }
      this.uploadFile(file, name)
      return false;
    },
    // 自定义上传
    uploadFile(file, name) {
      var formData = new FormData()
      formData.append('file', file)
      uploadDoctor(formData).then(res => {
        if (name == "idCardAvatar" || name == 'idCardNational') {
          this.formInfo[name] = [res.data[0]]
        } else {
          this.formInfo[name].push(res.data[0])
        }
      })
    },
    // 提交
    onClickSend() {
      if (this.formInfo.doctorName == '') {
        this.$message.warning(`请先完善个人信息!`);
      } else if (this.formInfo.practicingCard.length <= 0 || this.formInfo.idCardAvatar.length <= 0 || this.formInfo.idCardNational.length <= 0) {
        this.$message.warning(`请先完善个人信息!`);
      }
      let temporary = JSON.parse(JSON.stringify(this.formInfo))
      temporary.idCardAvatar = temporary.idCardAvatar[0]
      temporary.idCardNational = temporary.idCardNational[0]
      let data = {
        data: temporary,
        dv: this.userInfo.doctor.dv
      }
      changeDoctorInfo(data).then(async (res) => {
        if (res.code == 'A00000') {
          this.$message.success('提交成功');
          await this.getCurrentUser()
          this.userInfo = JSON.parse(localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : {}
          this.active = this.userInfo.doctor.authentication
          this.disabled = this.isModifiable()
          this.initialization()
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 初始化
    initialization() {
      this.formInfo = {
        doctorName: this.userInfo.doctor.doctorName ? this.userInfo.doctor.doctorName : '',
        hospital: this.userInfo.doctor.hospital ? this.userInfo.doctor.hospital : '',
        position: this.userInfo.doctor.position ? this.userInfo.doctor.position : '',
        remark: this.userInfo.doctor.remark ? this.userInfo.doctor.remark : '',
        qualificationCard: this.userInfo.doctor.qualificationCard ? this.userInfo.doctor.qualificationCard : [],
        practicingCard: this.userInfo.doctor.practicingCard ? this.userInfo.doctor.practicingCard : [],
        employeeCard: this.userInfo.doctor.employeeCard ? this.userInfo.doctor.employeeCard : [],
        idCardAvatar: this.userInfo.doctor.idCardAvatar ? [this.userInfo.doctor.idCardAvatar] : [],
        idCardNational: this.userInfo.doctor.idCardNational ? [this.userInfo.doctor.idCardNational] : [],
      }
    },
    // 判断是否可修改
    isModifiable() {
      // return !(this.active == 'AA' || this.active == 'A2')
      return false
    },
    // 获取当前登录用户
    async getCurrentUser() {
      await getCurrentUser().then(res => {
        if (res.code == 'A00000') {
          localStorage.setItem("userInfo", JSON.stringify(res.data[0]))
        }
      })
    },
  },
  async mounted() {
    await this.getCurrentUser()
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : {}
    console.log(this.userInfo, 'this.userInfo')
    this.active = this.userInfo.doctor.authentication
    this.disabled = this.isModifiable()
    if (this.active != 'AA') {
      this.initialization()
    }
  }
}
</script>

<style scoped lang="less">
.dialog-img-box {
  max-height: 60vh;
  overflow-y: auto;
}

.page-box {
  padding: 24px;
}

.upload-li {
  padding: 12px;
}

.authentication-note {
  color: #BD181E;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}

.upload-box {
  .identity-card-upload {
    width: 330px;
    padding: 10px 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-color: #F7F8FA;
    border-radius: 4px;

    .identity-card-left {
      flex: 1;
      overflow: hidden;
      margin-right: 8px;
      text-align: left;

      .identity-card-title {
        margin-bottom: 8px;
        color: #262626;
        font-weight: 500;
        font-size: 14px;
      }

      .identity-card-subhead {
        font-size: 12px;
        color: #A3A3A3;
      }
    }

    .identity-card-right {
      width: 140px;
      height: 84px;

      /deep/.el-upload--picture-card {
        width: 140px !important;
        height: 84px !important;
        line-height: normal !important;
      }

      .identity-card-img {
        width: 140px;
        height: 84px;
        vertical-align: bottom;
        border-radius: 4px;
      }
    }
  }

  .is-mgb-12 {
    margin-bottom: 12px;
  }

  /deep/.el-textarea {
    padding: 0 12px;
  }

  /deep/.el-button {
    background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
    color: #fff;
    width: 255px;
    height: 44px;
    border: none;
    border-radius: 50px;
    margin-top: 33px;
  }

  /deep/.el-textarea__inner {
    background: rgba(247, 248, 250, 1);
    border: none;
    height: 67px;
    padding: 10px;
    line-height: 22px;
    font-size: 15px;
    color: #000;
  }
}

.upload-bottom {
  padding: 16px 0;

  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }

  /deep/.el-upload-list--picture-card .el-upload-list__item>div {
    width: 100%;
    height: 100%;
  }

  /deep/.el-upload--picture-card {
    width: 100px;
    height: 100px;
    background: url("~@/assets/images/upload.png") center center no-repeat rgba(247, 248, 250, 1);
    background-size: 40px 40px;
    border: none;
  }

  /deep/.el-upload--picture-card i {
    display: none;
    align-items: center;
  }
}

.upload-bottom>div {
  display: flex;
}

.upload-top {
  display: flex;
  align-items: center;

  img {
    width: 40px;
  }

  .upload-text {
    text-align: left;
    margin-left: 8px;

    .upload-h {
      color: rgba(34, 34, 34, 1);
      font-size: 17px;
      font-weight: bold;
      line-height: 17px;
      margin-bottom: 8px;
    }

    .upload-p {
      color: rgba(153, 153, 153, 1);
      font-size: 12px;
      line-height: 12px;
    }
  }
}

.qualification-form {
  padding: 0 12px;
  margin-bottom: 12px;

  .qualification-input {
    color: rgba(34, 34, 34, 1);
    font-size: 15px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 49px;

    .qualification-left {}

    .qualification-right {
      /deep/.el-input__inner {
        border: none;
        text-align: right;
        padding: 0;
        width: 350px;
        background: transparent !important;
      }
    }
  }
}

.necessary-text {
  position: relative;
  padding-left: 10px;
}

.necessary-text::after {
  content: '*';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
  color: #EF4444;
  font-weight: 500;
}

.necessary-text-two {
  position: relative;
  display: inline-block;
  padding-right: 10px;
}

.necessary-text-two::after {
  content: '*';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
  color: #EF4444;
  font-weight: 500;
}

.qualification-top.active {
  background: rgba(43, 190, 190, 1);
}

.qualification-top {
  background: rgba(239, 158, 52, 1);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  height: 41px;
  margin-bottom: 14px;
  font-size: 14px;

  img {
    width: 15px;
    margin-right: 6px;
  }
}

.qualification-top.unsuccessful {
  background: #D82E35;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/Qualification.vue